import api from '../api/directors'
import apiNews from '../api/news'
import apiImi from '../api/imi'
import apiProperties from '../api/properties'

export const actionTypes = {
	RECEIVE_DIRECTORS: 'home/RECEIVE_DIRECTORS',
  RECEIVE_NEWS: 'home/RECEIVE_NEWS',
  RECEIVE_IMIS: 'home/RECEIVE_IMIS',
}

export const loadDirectors = () => {
	return (dispatch, getStore) => {
    api.fetchDirectorsList()
      .then((data) => {
      	dispatch(receiveDirectorsList(data))
      })
  }
}

function receiveDirectorsList(APIdata) {
  return {
    type: actionTypes.RECEIVE_DIRECTORS,
    data: APIdata.data
  }
}

export const loadNewsHome = () => {
  return(dispatch, getStore) => {
    apiNews.fetchNewsHome()
      .then((data) => dispatch(receiveNews(data)))
  }
}

function receiveNews(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEWS,
    data: APIdata.data
  }
}

export const loadImis = (pl) => {
  return(dispatch, getStore) => {
    apiImi.fetchImis(pl)
      .then((data) => dispatch(receiveImis(data)))
  }
}

function receiveImis(APIdata) {
  return {
    type: actionTypes.RECEIVE_IMIS,
    data: APIdata.data
  }
}



// WEBPACK FOOTER //
// ./src/actions/home.js